import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'grommet';

export const SearchSelect = ({
    labelKey,
    options,
    placeholder,
    updateFormData,
    valueKey,
    defaultValue,
    disabled,
    dropAlign,
}) => {
    const [searchOptions, setSearchOptions] = useState(options);

    useEffect(() => {
        let isActive = true;

        if (isActive) {
            setSearchOptions(options);
        }

        return () => {
            isActive = false;
        };
    }, [options]);

    const getLabel = (option) =>
        typeof labelKey === 'function' ? labelKey(option) : option[labelKey];

    const filterOptions = (input) => {
        const lowercasedInput = input.toLowerCase();
        if (!labelKey) {
            return setSearchOptions(
                options.filter((option) =>
                    option.toString().toLowerCase().includes(lowercasedInput),
                ),
            );
        }
        setSearchOptions(
            options.filter((option) =>
                (getLabel(option) ?? '')
                    .toLowerCase()
                    .includes(lowercasedInput),
            ),
        );
    };

    const resetOptions = () => {
        setSearchOptions(options);
    };

    const handleChange = ({ value }) => {
        updateFormData(value);
    };

    return (
        <Select
            placeholder={placeholder}
            // help="Help text"
            // icon={<Key />}
            labelKey={labelKey} // how to retrieve the label for each option (can be string or function)
            valueKey={valueKey}
            // messages={{ multiple: "string" }} // ????
            // name="the name of the attribute when in a form/formfield"
            // onMore={() => {}} // used to lazy fetch more options
            // onOpen={() => {}}
            searchPlaceholder="Search options..."
            options={searchOptions || []}
            onChange={handleChange}
            onClose={resetOptions}
            onSearch={filterOptions}
            showSelectedInline={true}
            defaultValue={defaultValue}
            disabled={disabled}
            dropAlign={dropAlign}
        />
    );
};

SearchSelect.propTypes = {
    labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    options: PropTypes.array,
    placeholder: PropTypes.string,
    updateFormData: PropTypes.func,
    valueKey: PropTypes.string,
    defaultValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    dropAlign: PropTypes.shape({
        top: PropTypes.string,
        bottom: PropTypes.string,
        left: PropTypes.string,
        right: PropTypes.string,
    }),
};
